import { useContext } from 'react';
import ClientStatusContext, { ClientStatusContextType } from './ClientStatusContext';

export default (): ClientStatusContextType => useContext<ClientStatusContextType>(ClientStatusContext);
